var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"can",rawName:"v-can",value:('profile.workplace.index'),expression:"'profile.workplace.index'"}]},[_c('work-places')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }